import { getDocumentElement, getDocumentElements, updateFieldTotal } from '../../Utils/Utils';

/**
 * Get the run off coefficient value to be used in the calculation
 * 
 * @param   {integer}   soilProfile
 * @param   {integer}   groundCover
 * @param   {integer}   rainfall
 * 
 * @returns {integer | null}
 */
const GetRunoffCoefficient = (soilProfile, groundCover, rainfall) => {
    const DivideLocationValue = parseFloat(getDocumentElement('#locationNS').value);
    let runoffCoefficientPercentage = null;

    if (soilProfile !== 0 &&
        groundCover !== 0 &&
        rainfall !== 0 &&
        DivideLocationValue !== 0
    ) {
        runoffCoefficientPercentage = [(0.0212 * rainfall) - 5.9464] * soilProfile * DivideLocationValue * groundCover;
    }

    return runoffCoefficientPercentage;
};

/**
 * Potential Catchment handler function that runs the calculation.
 * 
 * Calculation shown below  (answer will be in Megalitres)
 * (A x R x Y) ÷ 10 000
 * 
 * ---
 * KEY
 * ---
 * A = Catchment area
 * R = average rainfall in mm
 * Y = runoff coefficient % (see below for coefficient calculation)
 * 
 * ---
 * Runoff coefficient %
 * ---
 * [(0.0212 X average rainfall in mm*)-5.9464] x Soil Profile factor x Location North/ South of divide Factor x Cover Factor
 * 
 * @returns     {void}
 */
const PotentialCatchmentHandler = (catchmentArea, soilProfile, groundCover, subtotalField) => {
    const A = catchmentArea;
    const R = parseInt(getDocumentElement('#rainfall').value);
    const Y = GetRunoffCoefficient(soilProfile, groundCover, R);
    let calcResult = 0;

    if (A && R && Y) {
        calcResult = (A * R * Y) / 10000;
    }

    subtotalField.value = calcResult.toFixed(3);
};

/**
 * Potential catchment supply calculation container.
 * 
 * @returns     {void}
 */
export const PotentialCatchmentCalc = () => {
    const SoilProfileFields = getDocumentElements('#potential-catchment-supply [id^="soilProfile-"]');
    const CatchmentAreaFields = getDocumentElements('#potential-catchment-supply [id^="catchmentArea-"]');
    const GroundCoverFields = getDocumentElements('#potential-catchment-supply [id^="groundCover-"]');
    const CatchmentSubtotal = getDocumentElements('#potential-catchment-supply [id^="catchmentSubtotal-"]');
    const CatchmentMegaLTotalField = getDocumentElement('#catchmentTotal');
    const CatchmentMegaLSummaryTotalField = getDocumentElement('#tot_catchment');
    const FieldsToWatch = [SoilProfileFields, CatchmentAreaFields, GroundCoverFields]

    if (CatchmentAreaFields.length > 0) {
        FieldsToWatch.forEach((fields) => {
            fields.forEach((field, i) => {
                field.addEventListener('input', () => {
                    setTimeout(() => {
                        PotentialCatchmentHandler(
                            parseFloat(CatchmentAreaFields[i].value),
                            parseFloat(SoilProfileFields[i].value),
                            parseFloat(GroundCoverFields[i].value),
                            CatchmentSubtotal[i]
                        );

                        updateFieldTotal(CatchmentSubtotal, CatchmentMegaLTotalField, CatchmentMegaLSummaryTotalField);
                    }, 0)
                });
            });
        })
    }
    
    // listen for clone removed and re-update totals
    document.addEventListener('clonable:removed', e => {
        if (e.detail.id === 'catchment') {
            updateFieldTotal(CatchmentSubtotal, CatchmentMegaLTotalField, CatchmentMegaLSummaryTotalField);
        }
    });
};
